import {HubriseOrderContract} from 'common/api/hubrise/model/order/HubriseOrderContract';
import {HubriseLocationContract} from 'common/api/hubrise/model/location/HubriseLocationContract';
import {ExpectedDateCalculatorContract} from 'common/api/hubrise/service/ExpectedDateCalculatorContract';
import {ValidatorUtil} from 'common/util/ValidatorUtil';
import {DateTime} from 'luxon';

export class ExpectedDateCalculator implements ExpectedDateCalculatorContract {
    public static readonly DEFAULT_PREPARATION_DELAY_IN_MINUTES: number = 10;
    public static readonly DEFAULT_DELIVERY_DELAY_IN_MINUTES: number = 15;

    public calculateReadyDate(order: HubriseOrderContract, location: undefined | HubriseLocationContract): undefined | string {
        if (order.asap === true && ValidatorUtil.isISODate(order.created_at)) {
            const preparationMinutes: number = location?.preparation_time ?? ExpectedDateCalculator.DEFAULT_PREPARATION_DELAY_IN_MINUTES;

            return DateTime.fromISO(order.created_at, {setZone: true}).plus({minutes: preparationMinutes}).toISO();
        }

        if (ValidatorUtil.isISODate(order.confirmed_time)) {
            return DateTime.fromISO(order.confirmed_time, {setZone: true}).minus({
                minutes: (order.expected_time_pickup === true ? 0 : ExpectedDateCalculator.DEFAULT_DELIVERY_DELAY_IN_MINUTES)
            }).toISO();
        }

        if (ValidatorUtil.isISODate(order.expected_time)) {
            return DateTime.fromISO(order.expected_time, {setZone: true}).minus({
                minutes: (order.expected_time_pickup === true ? 0 : ExpectedDateCalculator.DEFAULT_DELIVERY_DELAY_IN_MINUTES)
            }).toISO();
        }

        return undefined;
    }
}
